import React, {Component} from 'react';
import "./Contact.scss"
import Navs from "../../components/Navs/Navs";
import ComTitle from "../../components/ComTitle/ComTitle";
import {titleObj} from "../../config/configPublic";
import Footer from "../../components/Footer/Footer";
import {message} from "antd";

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formText: {
                content: "",
                name: "",
                email: "",
                phone: "",
            },
            picUrl: ""
        }
    }

    componentDidMount() {
        this.getSubmitImg();
    }

    getSubmitImg() {
        this.$axios.apiList.getSubmitImg({})
            .then(res => {
                this.setState({
                    picUrl: res.data.picUrl
                })
            })
            .catch(error => {

            })
    }

    getSubmit() {
        let {formText} = this.state;
        if (formText.name === "") {
            message.error("请输入姓名",);
            return false;
        }
        if (!(/^1[3456789]\d{9}$/.test(formText.phone))) {
            message.error("请输入手机号码");
            return false;
        }
        if (formText.content === "") {
            message.error("请输入内容");
            return false;
        }
        let data = {
            "name": formText.name,
            "phone": formText.phone,
            "content": formText.content,
            "email": formText.content,
        };
        this.$axios.apiList.getFooterSubmit(data)
            .then(res => {
                message.success("提交成功");
            })
            .catch(error => {
                message.error("提交失败");
            })
    }

    setInputValue(e) {
        let {formText} = this.state;
        let {name, value} = e.target;
        formText[name] = value;
        this.setState({
            formText:formText
        });
    }

    render() {
        let {formText, picUrl} = this.state;
        return (
            <div className="contact">
                <div className="navs">
                    <Navs fullPageIndex={6}></Navs>
                </div>
                <div className="picUrl">
                    <img src={picUrl} alt=""/>
                </div>
                <div className="content">
                    <div className="address">
                        <ComTitle {...titleObj.contact}></ComTitle>
                        <div className="text">
                        感谢一直以来对宜兴交运物流的关注与信任。如果您想要更深入地了解我们的产品、价格及售后服务，请按照下面方式联系我们，我们会及时响应，为您提供贴心服务。
                        </div>
                        <div className="list">
                            <div className="item">
                                <div>
                                    我们的地址
                                </div>
                                <div>
                                宜兴经济技术开发区北环路东侧
                                </div>
                            </div>
                            <div className="item">
                                <div>
                                    联系电话
                                </div>
                                <div>
                                    客服中心：0510-87029605
                                </div>
                            </div>
                            <div className="item">
                                <div>
                                    企业邮箱
                                </div>
                                <div>
                                    zhongya56@126.com
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="submit">
                        <div className="title">
                            保持联系
                        </div>
                        <div className="border"></div>
                        <textarea placeholder="留言内容*" value={formText.content} name="content" onChange={e => {
                            this.setInputValue(e)
                        }} className="submit-content">

                        </textarea>
                        <div className="list">
                            <div className="item">
                                <input type="text" value={formText.name} name="name" onChange={e => {
                                    this.setInputValue(e)
                                }} placeholder="姓名*"/>
                            </div>
                            <div className="item">
                                <input type="text" value={formText.email} name="email" onChange={e => {
                                    this.setInputValue(e)
                                }} placeholder="电子邮箱"/>
                            </div>
                        </div>
                        <div className="list">
                            <div className="item">
                                <input type="text" value={formText.phone} name="phone" onChange={e => {
                                    this.setInputValue(e)
                                }} placeholder="电话*"/>
                            </div>
                            <div className="item">
                                <div className="btn" onClick={this.getSubmit.bind(this)}>
                                    提交留言
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tips">
                        <div>您好，如有任何问题或有意向合作请留言，我们将尽快回复您。感谢您对我们的帮助。</div>
                        <div>thank you for your support</div>
                    </div>
                </div>
                <Footer></Footer>
            </div>
        );
    }
}

export default Contact;
